'use client';

import { AuthLayout } from '@clara/ui';

export default function Layout({ children }: Readonly<{ children: React.ReactNode }>) {
  return <AuthLayout>{children}</AuthLayout>;
}
